import { Card, Heading, Icon } from '@ui/themed';
import { t } from 'i18next';
import { GROUP_ICONS, PARTNERS_I18N } from '../constants';
import type { Partner, PartnerGroup as PartnerGroupType } from '../types';
import { PartnerRow } from './partner-row';

const PAGE = PARTNERS_I18N.page;

export function PartnerGroup({
  group,
  onConfigure,
}: {
  group: PartnerGroupType;
  onConfigure: (partner: Partner) => void;
}) {
  const { type, partners } = group;

  return (
    <div>
      <div className="relative my-5 flex items-center gap-1.5">
        <div className="shrink-0">
          <Icon name={GROUP_ICONS[type]} size="xl" />
        </div>
        <Heading level="h3" style="md">
          {t(`${PAGE}.groups.${type}.title`)}
        </Heading>
      </div>
      <Card hidePadding>
        <ul className="divide-y divide-gray-200">
          {partners.map((partner) => (
            <PartnerRow key={partner.id} partner={partner} onConfigure={onConfigure} />
          ))}
        </ul>
      </Card>
    </div>
  );
}
